import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useToastContext } from '../../../../../../contexts'
import { getHandleableError } from '../../../../../../utils/errors/isXiaError'
import { requestDeleteDeliveryForecastDespatchAdviceItemPackaging } from '../../../../data/api'
import { DeletePackagingTableView } from './DeletePackagingTable.view'

type Props = {
  despatchAdviceId: string
  itemId: string
  id: string
}

export const DeletePackagingTableData: React.FC<Props> = ({
  despatchAdviceId,
  itemId,
  id,
}) => {
  const { t } = useTranslation()
  const { showToast } = useToastContext()
  const [isRequestRunning, setIsRequestRunning] = useState<boolean>(false)

  const deletePackagingTable = async () => {
    try {
      setIsRequestRunning(true)

      await requestDeleteDeliveryForecastDespatchAdviceItemPackaging(
        despatchAdviceId,
        itemId,
        id,
      )

      showToast({
        severity: 'success',
        summary: t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.delete.messages.success.summary',
        ),
        detail: t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.delete.messages.success.detail',
        ),
      })
    } catch (error) {
      const handleableError = getHandleableError(error)
      const errorMessage = handleableError.message

      showToast({
        severity: 'error',
        summary: t(
          'deliveryForecastDespatchAdvice.shippingDetails.delete.dialog.delete.messages.failure.summary',
        ),
        detail: errorMessage,
        sticky: true,
      })
    } finally {
      setIsRequestRunning(false)
    }
  }

  return (
    <DeletePackagingTableView
      isRequestRunning={isRequestRunning}
      handleDelete={deletePackagingTable}
    />
  )
}
